module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-d3510a915c790cce9510dd41eb326371.svg#sports",
      toString: function () {
        return this.url;
      }
    }